var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',[_c('FontAwesomeIcon',{attrs:{"icon":"clipboard-list"}}),_vm._v(" Todo List")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }